import { useState, useEffect } from 'react';

import { VENUES_TAXONOMY_KEY } from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';

import cx from 'classnames';

import {
  PartialVendorSearch,
  PartialTaxonomyNode,
} from '~/pages/couples/explore/components/SearchResults/types/types';
import createCanonicalUrl from '~/pages/couples/explore/util/canonicalUrl';
import { LocationOrAllMarketsType } from '~/types/responseTypes';
import { getSearchLocationForBriefLocation, setSearchedLocation } from '~/util/searchUtils';
import { ALL_MARKETS } from '~/util/searchUtils';

import { NotNullMembersBriefLocation } from '../../util/types';
import { InlineSearchBar } from '../SearchBar/InlineSearchBar';
import StackedSearchBar from '../SearchBar/StackedSearchBar';

import styles from './overlaySearchBar.module.less';

const DEFAULT_TAXONOMY_NODE: PartialTaxonomyNode = {
  key: VENUES_TAXONOMY_KEY,
  label: 'Venues',
};

type OverlaySearchBarProps = {
  weddingLocation?: NotNullMembersBriefLocation;
  defaultTaxonomyNode?: PartialTaxonomyNode;
  includeSavedSearch?: boolean;
  className?: string;
  verticalStacked?: boolean;
  isClpRedesign?: boolean;
};

export const OverlaySearchBar: React.FC<OverlaySearchBarProps> = (props) => {
  const {
    weddingLocation,
    defaultTaxonomyNode = DEFAULT_TAXONOMY_NODE,
    verticalStacked = false,
    includeSavedSearch = false,
    className,
    isClpRedesign,
  } = props;

  const [selectedLocation, setSelectedLocation] = useState<LocationOrAllMarketsType>();
  const [selectedTaxonomyNode, setSelectedTaxonomyNode] = useState<PartialTaxonomyNode | null>(
    defaultTaxonomyNode
  );

  const updateSelectedLocation = (location: LocationOrAllMarketsType) => {
    setSearchedLocation(location);
    setSelectedLocation(location);
  };

  useEffect(() => {
    if (defaultTaxonomyNode) {
      setSelectedTaxonomyNode(defaultTaxonomyNode);
    }
  }, [defaultTaxonomyNode]);

  useEffect(() => {
    if (weddingLocation) {
      setSelectedLocation(getSearchLocationForBriefLocation(weddingLocation));
    }
  }, [weddingLocation]);

  const searchBarProps = {
    selectedTaxonomyNode,
    setSelectedTaxonomyNode,
    selectedLocation: selectedLocation || ALL_MARKETS,
    updateSelectedLocation,
    navigateToSrp: (req: PartialVendorSearch) => {
      const { canonicalUrl: to } = createCanonicalUrl({
        vendorSearch: req,
        facetsByVendorType: {}, // No facets involved
      });
      window.location.assign(to);
    },
    includeSavedSearch,
    isClpRedesign,
  };

  const SearchBarComponent = verticalStacked ? StackedSearchBar : InlineSearchBar;

  return (
    <div
      className={cx(
        styles.overlaySearchBar,
        {
          [styles.verticallyStacked]: verticalStacked,
        },
        className
      )}
    >
      <SearchBarComponent {...searchBarProps} />
    </div>
  );
};
